module.exports = __webpack_public_path__ + "assets/img/1411587607432_.pic_hd.0f51c391.jpg";